import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Field, reduxForm, Form, formValueSelector,
} from 'redux-form';
import { Link } from 'react-router-dom';
import { withRouter } from 'withRouter';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Input from 'components/Form/Input';
import InputPassword from 'components/Form/InputPassword';
import { resetPasswordRequest } from 'containers/Login/actions';
import validation from './validation';
import ResetPassword from '../ForgotPassword/ResetPassword';
import GoogleButton from 'containers/Auth/SSO/GoogleButton';
import MicrosoftButton from 'containers/Auth/SSO/MicrosoftButton';
import { VuiButton } from '@topkamera/viso-ui';

class LoginForm extends Component {
  state = {
    showConfirmationPage: false,
    showResetPage: false,
    resetEmail: '',
    step: 'email',
  }

  async componentDidUpdate(prevProps) {
    const currentEmail = this.props.email
    const prevEmail = prevProps.email

    if (currentEmail !== prevEmail) {
      this.props.onEmailChange?.(currentEmail)
    }
  }

  redirectToForgetPassword = () => {
    this.props.router.navigate('/forgot-password');
  }

  onForgetPassword = () => {
    this.setState({ showResetPage: true });
  }

  goToPasswordStep = () => {
    this.setState({ step: 'password' })
    this.props.onStepChange?.('password')
  }

  goToEmailStep = () => {
    this.setState({ step: 'email' })
    this.props.onStepChange?.('email')
  }

  render() {
    const { isLoading, password, email } = this.props;

    if (this.state.showResetPage) {
      return (
        <ResetPassword
          onCallback={email => this.setState({ showConfirmationPage: true, resetEmail: email })}
          onClose={() => this.setState({ showResetPage: false })}
        />
      );
    }

    return (
      <Form
        onSubmit={this.props.handleSubmit((values, dispatch, props) => {
          if (this.state.step === 'email') {
            this.goToPasswordStep();
          } else {
            this.props.onSubmit(values)
          }
        })}
        className="login-custom"
      >
        {this.state.step === 'email' ?
          <div className='sso-page-form'>
            <div className='sso-page-form__field sso-page-form__field--margin-md'>
              <Field
                name="email"
                id="email"
                dataCy="email"
                component={Input}
                label="Your email"
                className='sso-page-field'
              />
            </div>
            <div className="sso-page-form__button sso-page-form__button--margin-md">
              <VuiButton
                disabled={!this.props.valid || isLoading || !email}
                isLoading={isLoading}
                onClick={this.goToPasswordStep}
                color='accent0'
                style='filled'
                radius='pill'
                label='Continue'
                isBlock
              />
            </div>
            <div className='sso-page-form__footer'>
              <div className="sso-page-form__helper">Or continue with</div>
              <GoogleButton />
              <MicrosoftButton />
              <div className="sso-page-form__helper sso-page-form__helper--padded">
                Don't have an account?{' '}
                <a href='https://viso.ai/get-a-demo'
                  target="_blank" rel="noopener noreferrer"
                  className="accent0">
                  Sign up
                </a>
              </div>
            </div>
          </div>
          :
          <div className='sso-page-form'>
            <div className='sso-page-field'>
              <Field
                name="password"
                id="password"
                dataCy="password"
                component={InputPassword}
                label="Password"
              />
            </div>
            <div className="sso-page-form__helper sso-page-form__helper--right">
              <Link to="/login/resetpassword" className="">
                Forgot password?
              </Link>
            </div>
            <div className="sso-page-form__button">
              <VuiButton
                disabled={!this.props.valid || isLoading || !password}
                isLoading={isLoading}
                color='accent0'
                style='filled'
                radius='pill'
                label='Log in'
                type='submit'
                isBlock
              />
            </div>
            <div className="sso-page-form__helper sso-page-form__helper--padded-lg">
              Not {email}?{' '}
              <a href=''
                target="" rel="noopener noreferrer"
                className="accent0"
                onClick={(e) => {
                  e.preventDefault()
                  this.goToEmailStep()
                }}
              >
                Go back
              </a>
            </div>
          </div>
        }
      </Form>
    );
  }
}

LoginForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  valid: PropTypes.bool.isRequired,
};

const selector = formValueSelector('LOGIN_FORM');

function mapStateToProps(state) {
  return {
    email: selector(state, 'email'),
    password: selector(state, 'password'),
  };
}

const withConnect = connect(mapStateToProps, { resetPasswordRequest });

export default compose(
  reduxForm({
    form: 'LOGIN_FORM',
    validate: validation,
  }),
  withRouter,
  withConnect,
)(LoginForm);
